import React from "react"
import classnames from "classnames/bind"
// Style
import displayStyle from "../../style/components/projects/dispaly.module.scss"

const Display = props => {
  return pug`
    div.col-12.my-8.px-0(className=classnames(displayStyle.display,props.className))
      span(className=props.style)=props.mark
  `
}

const DisplaySizePlus = props => {
  return pug`
    div.col-12.my-8(className=classnames(displayStyle.display,displayStyle.size_plus,props.className))
      span(className=props.style)=props.mark
  `
}
export { Display, DisplaySizePlus }
